import "./spotlight.bundle.js";

import { addElementEvents, removeElementEvents } from "../utils/events";
import { hasClass, addClass } from "../utils/dom";

const showGallery = (gallery, index) => {
  try {
    Spotlight.show(gallery, { index });
  } catch (e) {}
};

const initGallery = element => {
  const images = element.querySelectorAll("img");

  if (hasClass(element, "with-gallery")) {
    // return;
  }

  addClass(element, "with-gallery");

  const galleryHandler = e => {
    if (element._gallery && element._gallery.length)
      showGallery(
        element._gallery,
        e && e.target && e.target._gallery_index ? e.target._gallery_index : 1
      );
  };

  if (images) {
    element._gallery = [];
    let index = 1;
    Array.prototype.forEach.call(images, image => {
      let src = image.getAttribute("data-full-url");
      let title = image.getAttribute("title");
      let description = "";

      src = src && src.length ? src : image.getAttribute("src");
      src = src && src.length ? src : image.getAttribute("data-src");

      title = title && title.length ? title : image.getAttribute("title");
      title = title && title.length ? title : image.getAttribute("alt");
      title = title && title.length ? title : " ";

      description = description && description.length ? description : " ";

      src && src.length && element._gallery.push({ src, title, description });

      let icon = document.createElement("span");
      icon.className = "icon-focus";
      icon._gallery_index = index;
      image.parentNode.insertBefore(icon, image.nextSibling);

      removeElementEvents(
        image.closest(".blocks-gallery-item"),
        ["click"],
        galleryHandler
      );

      if (!hasClass("body", "wp-admin")) {
        let c = image.closest(".blocks-gallery-item");
        c._gallery_index = index;
        image._gallery_index = index;
        addElementEvents(c, ["click"], galleryHandler);
      }

      index = index + 1;
    });
  }
};

const initGalleries = () => {
  const elements = document.querySelectorAll(".wp-block-gallery");
  if (elements) {
    Array.prototype.forEach.call(elements, element => {
      let section = element.closest("section");
      section && initGallery(section);
    });
  }
};

export default initGalleries;
